module.exports = __webpack_public_path__ + "img/20160819_111401-e1476995529285-300x169.163bdbb3.jpg";